import $ from 'jquery';
window.$ = window.jQuery = $;

export function hello() {
    $(".is-number").on('input', function() {
        const input = this;
        const cursorPosition = input.selectionStart;
        const originalValue = input.value;
        const newValue = originalValue.replace(/[^0-9]/g, '');
        
        if (originalValue !== newValue) {
            $(this).val(newValue);
            // Count how many characters were removed before the cursor position
            let removedBeforeCursor = 0;
            for (let i = 0; i < cursorPosition; i++) {
                if (originalValue[i] && !/[0-9]/.test(originalValue[i])) {
                    removedBeforeCursor++;
                }
            }
            // Set cursor position accounting for removed characters
            const newCursorPosition = cursorPosition - removedBeforeCursor;
            input.setSelectionRange(newCursorPosition, newCursorPosition);
        }
    });
}
function addErrorMessage(errorElement,message) {
    $(errorElement).html(message);
}
function emptyTimeSelector() {
    $('#time-selector').empty();
}
function hideTimeSelector() {
    $('#time-select-wrapper').hide();
}
function showTimeSelector() {
    $('#time-select-wrapper').show();
}
function showSearchButton(){
    $('#web-reservation-update-btn').hide()
    $('#seat-search-btn').show()
}
function showUpdatedButton(){
    $('#seat-search-btn').hide()
    $('#web-reservation-update-btn').show()
}
function extractTime(dateTimeString) {
   if(dateTimeString !== null){
       let dateTimeParts = dateTimeString?.split("T");
       return dateTimeParts[1];
   }
   else return null;

}
function extractDate(dateTimeString) {
    if(dateTimeString !== null){
        let dateTimeParts = dateTimeString?.split("T");
        return dateTimeParts[0];
    }
    else return null;
}
function showSearchModal(){
    if (typeof LoadingComponent !== 'undefined') {
        LoadingComponent.show('検索中...');
    }
}
function hideSearchModal(){
    if (typeof LoadingComponent !== 'undefined') {
        LoadingComponent.hide();
    }
}

function showPlanError(){
    addErrorMessage('#number-error',"プランの日時や人数などの条件に満たさないため、選択中のプランは予約できません。")
}

function showNumberError(){
    addErrorMessage('#number-error',"該当の日時にご指定の人数で席が確保できませ<br> ん。条件を変更してください。")
}
function hideNumberError(){
    addErrorMessage('#number-error',null)
}
function getSelectedDate() {
    return $('#date').val();
}
function getSelectedTime() {
    return $('#time-selector').val();
}
function getSelectedNumberOfPeople() {
    return $('#people-selector').val();
}
function checkSeatForDefaultDate(){
    let planId = $('#reservation-plan-id').data('plan_id');
    let seatTypeId = $('#reservation-seat-type-id').data('reservation_seat_type_id');
    let reservationId = $('#reservation-id').data('reservation_id');

    if(planId && planId !==''){
        let originalDate = $('#reservation-start-date').data('reservation_start_date');
        jQuery.ajax({
            type: "get",
            url: `/shops/usen_plans/${planId}`,
            data: {
                "shop_id": $('#bespo-shop-id-element').data('bespo_shop_id'),
                "number_of_people":getSelectedNumberOfPeople(),
                "seat_type_id":seatTypeId,
                "external_reservation_id":reservationId,
                "date":originalDate,
            },
            success: function (res) {
                res.data ||= [];
                if (res.data.length === 0) {
                    setSelectableDates(false)
                } else {
                    setSelectableDates(true)
                }

            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                setSelectableDates(false)
            }
        });

    }
    else{

        let originalDate = $('#reservation-start-date').data('reservation_start_date');
        jQuery.ajax({
            type: "get",
            url: `/shops/timetable`,
            data: {
                "shop_id": $('#bespo-shop-id-element').data('bespo_shop_id'),
                "number_of_people":getSelectedNumberOfPeople(),
                "date":originalDate,
            },
            success: function (res) {
                res.data ||= [];
                if (res.data.length === 0) {
                    setSelectableDates(false)
                } else {
                    setSelectableDates(true)
                }

            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                setSelectableDates(false)
            }
        });
    }

}
function getPlanTimetableSeats(options = {}) {
    let planId = $('#reservation-plan-id').data('plan_id');
    let seatTypeId = $('#reservation-seat-type-id').data('reservation_seat_type_id');
    let reservationId = $('#reservation-id').data('reservation_id');
    let selectedTime = $('#time-selector').val()
    showSearchModal()
    jQuery.ajax({
        type: "get",
        url: `/shops/usen_plans/${planId}`,
        data: {
            "shop_id": $('#bespo-shop-id-element').data('bespo_shop_id'),
            "number_of_people": getSelectedNumberOfPeople(),
            "date": getSelectedDate(),
            "seat_type_id":seatTypeId,
            "external_reservation_id":reservationId
        },
        success: function (res) {
            hideSearchModal()
            res.data ||= [];
            if (res.data.length === 0) {
                emptyTimeSelector()
                showPlanError()
                showSearchButton()
            } else {
                hideNumberError();
                showTimeSelector()
                renderTimeButtons(res.data, selectedTime);
                showUpdatedButton()
            }

        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            hideSearchModal()
        }
    });
}
function getTimetableSeats(options = {}) {
    let selectedTime = $('#time-selector').val()
    showSearchModal()
    jQuery.ajax({
        type: "get",
        url: `/shops/timetable`,
        data: {
            "shop_id": $('#bespo-shop-id-element').data('bespo_shop_id'),
            "number_of_people": getSelectedNumberOfPeople(),
            "date": getSelectedDate(),
        },
        success: function (res) {
            hideSearchModal()
            res.data ||= [];
            if (res.data.length === 0) {
                emptyTimeSelector()
                showNumberError()
                showSearchButton()
            } else {
                hideNumberError();
                showTimeSelector()
                renderTimeButtons(res.data, selectedTime);
                showUpdatedButton()
            }

        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            hideSearchModal()
        }
    });
}
function convertDateFormat(inputDate) {
    let parts = inputDate.split('/');
    return parts[0] + '-' + parts[1] + '-' + parts[2];

}
function renderTimeButtons(data, selectedTime) {

  const timeSlotsScroller = $(".time-slots-scroller");
  timeSlotsScroller.empty().show();

  let selectedTimeOnly = selectedTime ? extractTime(selectedTime)?.substring(0, 5) : null;
  
  const availableTimes = data.map(datetime => {
    let date = new Date(datetime);
    let timeString = date.toTimeString().split(' ')[0].substring(0, 5); 
    return { datetime, timeString };
  });

  let matched = false;

  availableTimes.forEach(({ datetime, timeString }) => {
    const isActive = selectedTimeOnly && selectedTimeOnly === timeString;
    if (isActive) matched = true;

    const button = $(`
      <button type="button"
        class="time-slot ${isActive ? 'active' : ''}"
        data-time="${timeString}"
        data-datetime="${datetime}"
       >
        ${timeString}
      </button>
    `);

    button.on('click', function () {
      $(".time-slot").removeClass('active');
      $(this).addClass('active');
      $("#selected-time").val(datetime);

      $(".time-slot").each(function () {
        const $this = $(this);
        const isThisActive = $this.hasClass('active');
        $this.css({
          'color': isThisActive ? 'var(--md-sys-color-on-surface)' : 'var(--md-sys-color-on-surface)',
          'border': isThisActive? '2px solid var(--md-sys-color-outline)' :'1px solid var(--md-sys-color-outline-variant)',
          'background': isThisActive ? 'var(--md-sys-color-on-surface-variant-opacity-10)' : 'none',
           
        });
      });
    });

    timeSlotsScroller.append(button);
  });

  if (!matched && availableTimes.length > 0) {
    const defaultTime = availableTimes[0].datetime;
    $(`.time-slot[data-datetime="${defaultTime}"]`).trigger('click');
  }
}


function setSelectableDates(defaultDate){
    let originalDate = $('#reservation-start-date').data('reservation_start_date');
    let currentDate = new Date();
    if(!defaultDate){
        $('#date-selector').append('<option value="">日付を選択してください</option>');
        $('#seat-search-btn').addClass('disabled')
    }
    for (let i = 0; i < 30; i++) {
        let date = new Date(currentDate);
        date.setDate(currentDate.getDate() + i);
        let dateString = date.toISOString().slice(0,10); // Format: YYYY-MM-DD
        $('#date-selector').append('<option value="' + dateString + '">' + getDisplayDate(date) + '</option>');
    }
    if(defaultDate===true){
        $('#date-selector').val(convertDateFormat(originalDate))
    }
}
function getDisplayDate(date){
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return month + "月 " + day + " 日";
}

function  isUpdatePage(){
    let currentURL = window.location.href;
    return currentURL.includes("change")
}
function formatTime(isoTime) {
    let date = new Date(isoTime);
    let hours = date.getHours().toString().padStart(2, '0'); // Ensure hours always have 2 digits
    let minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure minutes always have 2 digits
    return hours + ':' + minutes;
}
function setSelectTime(data,selectedTime){
    emptyTimeSelector()
    for (let i = 0; i < data.length; i++) {
        let time = formatTime(data[i]);
        $('#time-selector').append('<option value="' + data[i] + '">' + time + '</option>');

    }
    if(selectedTime !== null){
        let extractedTime = extractTime(selectedTime)
        let timeOnlyData = data.map(dateTimeString => extractTime(dateTimeString));
        if(timeOnlyData.includes(extractedTime)){
            let selectedDateTime = extractDate(data[0])+'T'+extractedTime
            $('#time-selector').val(selectedDateTime)
        }
        else{
            emptyTimeSelector()
            showNumberError()
            showSearchButton()
        }
    }
}
function isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date) && dateString.match(/^\d{4}-\d{2}-\d{2}$/);
}
$(document).ready(function() {
    if(isUpdatePage()){
        showSearchButton();
        hideTimeSelector();
        checkSeatForDefaultDate()
    }
    $('#date-arrow').click(function(event) {
        $('#date-selector').click();
        event.stopPropagation();
    });

    $(document).click(function() {
        $('#date-selector').removeClass('open');
    });
    let reservationCode = $('#reservation-data-element').data('reservation_code');
    let planName = $('#reservation-plan-name').data('reservation_plan_name');
    let planNotes = $('#reservation-plan-notes').data('reservation_plan_notes');
    let planPrice = $('#reservation-plan-price').data('reservation_plan_price');
    let seatName = $('#reservation-seat-name').data('reservation_seat_name');
    let seatChargeFee = $('#reservation-seat-charge-fee').data('reservation_seat_charge_fee');
    let freeText = $('#reservation-free-text').data('reservation_free_text');
    let freeTextTitle = $('#reservation-free-text-title').data('reservation_free_text_title');
    let shopIdCode = $('#shop-data-element').data('shop_id_code');
    let isExpired = $('#reservation-is-expired').data('reservation_is_expired');
    $('#date-selector').change(function() {
        showSearchButton()
    });
    $('#people-selector').change(function (){
       showSearchButton()
    })
    $('#seat-search-btn').click(function () {
        let planId = $('#reservation-plan-id').data('plan_id');
        if(planId && planId!==''){
            getPlanTimetableSeats();
        }
        else{
            getTimetableSeats();
        }
    })
    $('#date-selector').on('change', function () {
        const selectedDate = $(this).val();
        if (isValidDate(selectedDate)) {
            if (!isExpired){
                $('#seat-search-btn').removeClass('disabled')
            }
        } else {
            $('#seat-search-btn').addClass('disabled')
        }
    });
    $('#web-reservation-cancel-btn').click(function() {
        let cancelModal =  $("#modal-cancel-web-reservation")
        cancelModal.modal({
            backdrop: 'static',
            keyboard: false
        });
        cancelModal.modal('show')
        $(".success-content").hide();
        $(".failure-content").hide();
        $(".loader-content").show();
        jQuery.ajax({
            type: "patch",
            url: `/shops/${shopIdCode}/reservations/web-cancel?t=${reservationCode}`,
            data: {
                plan_name:planName,
                plan_notes:planNotes,
                plan_price:planPrice,
                seat_name:seatName,
                seat_charge_fee:seatChargeFee,
                free_text:freeText,
                free_text_title:freeTextTitle
            },
            success: function (res) {
                $('#web-reservation-cancel-btn').prop('disabled', true).addClass('disabled');
                $(".loader-content").hide();
                $(".success-content").show();
                $(".modal-backdrop").show()
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                cancelModal.modal('dispose')
                cancelModal.modal({
                    backdrop: true,
                    keyboard: true
                })
                $(".loader-content").hide();
                $(".failure-content").show();
                cancelModal.on('hidden.bs.modal', function () {
                    $(".modal-backdrop").hide()
                });
            }
        });
    });
    // $('#web-reservation-update-btn').click(function() {
    //     let updateModal =  $("#modal-update-web-reservation")
    //     updateModal.modal({
    //         backdrop: 'static',
    //         keyboard: false
    //     });
    //     updateModal.modal('show')
    //     $(".success-content").hide();
    //     $(".failure-content").hide();
    //     $(".loader-content").show();
    //     if(getSelectedDate() !== null && getSelectedTime() !== null && getSelectedDate() !== '' && getSelectedTime() !== ''){
    //         let dateTimeStr = getSelectedDate()+" "+ formatTime(getSelectedTime())
    //         jQuery.ajax({
    //             type: "patch",
    //             url: `/shops/${shopIdCode}/reservations/web-change?t=${reservationCode}`,
    //             data: {
    //                 start_time: dateTimeStr,
    //                 number_of_people: parseInt(getSelectedNumberOfPeople()),
    //                 shop_id_code: shopIdCode,
    //                 plan_name:planName,
    //                 plan_notes:planNotes,
    //                 plan_price:planPrice,
    //                 seat_name:seatName,
    //                 seat_charge_fee:seatChargeFee,
    //                 free_text:freeText,
    //                 free_text_title:freeTextTitle
    //             },
    //             success: function (res) {
    //                 $(".loader-content").hide();
    //                 $(".success-content").show();
    //                 $(".modal-backdrop").show()
    //             },
    //             error: function(XMLHttpRequest, textStatus, errorThrown) {
    //                 updateModal.modal('dispose')
    //                 updateModal.modal({
    //                     backdrop: true,
    //                     keyboard: true
    //                 })
    //                 $(".loader-content").hide();
    //                 $(".failure-content").show();
    //                 updateModal.on('hidden.bs.modal', function () {
    //                     $(".modal-backdrop").hide()
    //                 });
    //             }
    //         });
    //     }
    //     else{
    //         updateModal.modal('dispose')
    //         updateModal.modal({
    //             backdrop: true,
    //             keyboard: true
    //         })
    //         $(".loader-content").hide();
    //         $(".failure-content").show();
    //         updateModal.on('hidden.bs.modal', function () {
    //             $(".modal-backdrop").hide()
    //         });
    //     }
    // });
});
